import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";

import {
    preteritoIndefinidoExplanation,
    PreteritoIndefinidoExamplesData,
    preteritoIndefinidoRegular,
    preteritoIndefinidoStemChange,
    preteritoIndefinidoStrongIrregulars,
    preteritoIndefinidoCompleteIrregulars
} from "src/data/individual-topics/PastSimple";

const PreteritoIndefinidoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>
            <div className="section">
                <ExplanationCard cardData={preteritoIndefinidoExplanation} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {PreteritoIndefinidoExamplesData.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Regular Conjugation",
                        verbs: preteritoIndefinidoRegular,
                    }}
                />
            </div>

            <div className="section">
                <ExplanationCard cardData={preteritoIndefinidoStemChange} />
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Strong Irregular Verbs",
                        verbs: preteritoIndefinidoStrongIrregulars,
                    }}
                />
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Complete Irregular Verbs",
                        verbs: preteritoIndefinidoCompleteIrregulars,
                    }}
                />
            </div>
        </div>
    );
};

const PreteritoIndefinidoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Past Simple"
            Page={<PreteritoIndefinidoContent />}
        />
    );
};

export default PreteritoIndefinidoScreen;
